import { RoutingRule } from './RoutingRule.types';

export const readRoutingRule = (
  rule: { all?: RoutingRule[] } | undefined | null,
) =>
  rule?.all
    ? Object.fromEntries(rule.all.map((r) => [r.path.split('$.')[1], r.value]))
    : { '': [''] };
